import { get } from 'lodash';

import { DEFAULT_DPI, LAZY_OFF, LAZY_ON, FILTERS } from '../../../constants';

export const normalizePictureData = (picture, title, options, isNotCropImage) => {
  const imgSrc = get(picture, options.imageResolution || DEFAULT_DPI);

  return {
    ...picture,
    src: imgSrc,
    lazyload: options.preload ? LAZY_OFF : LAZY_ON,
    lowEnd: options.lowEnd,
    preload: options.preload || false,
    title,
    isNotCropImage,
    width: get(picture, 'tags.width'),
    height: get(picture, 'tags.height'),
  };
};

const isAbsoluteUrl = (url) => /^https?:\/\//.test(url);

export const removePolygonParamToUrl = (params) => {
  try {
    if (typeof window === 'undefined' || !window.location?.search) {
      return params;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const polygonLocation = searchParams.get(FILTERS.IDS.POLYGON_LOCATION);

    return !polygonLocation
      ? (() => {
          const { polygon_location, ...rest } = params || {};

          return rest;
        })()
      : params;
  } catch (error) {
    return params;
  }
};

export const appendPolygonParamToUrl = (rawUrl, polygonParam) => {
  try {
    if (!rawUrl || typeof rawUrl !== 'string') {
      return rawUrl;
    }

    if (typeof window === 'undefined' || !window.location?.origin) {
      return rawUrl;
    }

    const urlObj = isAbsoluteUrl(rawUrl)
      ? new URL(rawUrl)
      : new URL(rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`, window.location.origin);

    if (polygonParam) {
      urlObj.searchParams.set(FILTERS.IDS.POLYGON_LOCATION, polygonParam);
    }

    return urlObj.toString();
  } catch (e) {
    return rawUrl;
  }
};
